<div class="modal-header">
	<h3 class="modal-title" id="modal-title-id">
		<span>{{LOCALIZATION.importGeoData}}</span>
	</h3>
</div>
<div class="modal-body thumbs-loader">
	<div style="max-height:400px;overflow-y:auto;overflow-x:hidden">
		<div class="col-xs-12">
				<div class="dropzone background-light" dropzone>
					<div style="flex:1">
						<div>
							<p>
							<em>{{ LOCALIZATION.dragDropRecordsLimit | formatString: 1 }}.</em>
							<em>{{ LOCALIZATION.dragDropRecordsValidGeoPackageTypes }}</em>
							</p>
						</div>	
						<label 
						    for="file-upload" 
						    class="btn btn-circle btn-lg btn-primary z-depth-1" 
						    title="{{LOCALIZATION.addFile}}">
						    <i class="fa fa-file" aria-hidden="true"></i>
						</label>
						<input id="file-upload"
						       type="file" 
						       accept=".zip" 
						       multiple
						       fileinput 
						       (filesSelected)="onFilesSelected($event)" 
						       class="hidden-input" />											
					</div>
				</div>
			<div *ngIf="uploadStatus == 'PENDING'" class="loader"></div>
			<div *ngIf="geometries && geometries.length > 0">
				<div>
					<span>Attribute to use for naming:</span>				
					<select class="form-control" [(ngModel)]="fieldToUse" name="geometryFields" aria-labelledby="geometryFields">
						<option *ngFor="let field of fields" value="{{field}}">{{field}}</option>
					</select>
				</div>
				<br>
				<div>
					<button class="btn btn-xs btn-primary" (click)="toggleGeometries(true)">{{LOCALIZATION.all}}</button>
					<button class="btn btn-xs btn-primary" (click)="toggleGeometries(false)">{{LOCALIZATION.none}}</button>
				</div>
				<br>
				<span><em>Limiting to 50 results</em></span>
				<ul *ngFor="let geometry of geometries; let i = index;" class="list-group">
					<li class="list-group-item" title="{{geometry.geo}}">
						<label style="display:inline;"class="control control--checkbox">
                        	<input type="checkbox" [(ngModel)]="geometries[i].selected" name="geometry{{i}}" attr.aria-label="Select {{i}}" />
                        	<div class="control__indicator"></div>
                    	</label>
                    	<span>{{geometry.properties[fieldToUse]}}</span>
                    	<p>{{geometry.geo}}</p>
                	</li>
				</ul>
			</div>
		</div>
	</div>
</div>
<div class="modal-footer">
	<button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.close}}</button>
	<button class="btn btn-primary" type="button" (click)="save()" [disabled]="!geometries || geometries.length == 0">{{LOCALIZATION.submit}}</button>
</div>
